import { Icon, Stack } from "@mui/material";
import React from "react";
import Typography from "@mui/material/Typography";

export default function PageTitle({ page }) {
  return (
    <Stack direction="row" spacing={2} sx={{ marginBottom: "15px" }}>
      <div style={{ paddingTop: "5px" }}>
        <Icon sx={{ fontSize: "1.8rem" }}>{page.icon}</Icon>
      </div>
      <Typography variant="h1" sx={{ fontSize: "1.8rem", fontWeight: 500 }}>
        {page.label}
      </Typography>
    </Stack>
  );
}
